import { AI_FEEDBACK_TYPES, withErrorBoundary } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Button, TextStyle } from '@superops/ui-design-system';
import React, { useReducer, useState } from 'react';
import { createPortal } from 'react-dom';
import { FormattedMessage } from 'react-intl';
import AIFeedbackTooltip from './AIFeedbackTooltip';

const AIFeedback = ({
  sendActivity,
  hideCustomFeedback,
  isHideFeedback,
  hideThumbsUp,
  hideTitle,
  buttonVariant
}) => {
  const feedbackAnchorRef = React.useRef(null);

  const getButtonVariant = () => {
    switch (buttonVariant) {
      case 'primary':
        return {
          primary: true
        };
      case 'secondary':
        return {
          secondary: true
        };
      case 'aiPrimary':
        return {
          aiPrimary: true
        };
      case 'aiPrimaryLight':
        return {
          aiPrimaryLight: true
        };
      case 'plainSecondary':
        return {
          plainSecondary: true
        };
      case 'plain':
        return {
          plain: true
        };
      case 'default':
        return {};
      default:
        return {
          aiTertiary: true
        };
    }
  };

  const buttonVariantData = getButtonVariant();

  const [isThumbsUpClicked, setIsThumbsUpClicked] = useState(false);
  const [isThumbsDownClicked, setIsThumbsDownClicked] = useState(false);

  const [hideFeedback, setHideFeedback] = useState(isHideFeedback || false);
  const [showFeedbackTooltip, toggleFeedbackTooltip] = useReducer(
    (s) => !s,
    false
  );

  const sendFeedback = (feedbackComment) => {
    if (sendActivity) {
      sendActivity({
        feedbackComment: feedbackComment,
        type: AI_FEEDBACK_TYPES.NOT_HELPFUL
      });
    }
    setTimeout(toggleFeedbackTooltip, 2000);
    setTimeout(() => {
      setHideFeedback(true);
    }, 2500);
  };

  const feedbackTooltip =
    showFeedbackTooltip &&
    feedbackAnchorRef.current &&
    createPortal(
      <AIFeedbackTooltip
        onSend={(feedbackComment) => {
          sendFeedback(feedbackComment);
        }}
        onClose={() => toggleFeedbackTooltip()}
      />,
      feedbackAnchorRef.current
    );

  const thumbsUp = () => {
    setIsThumbsUpClicked(true);

    if (sendActivity) {
      sendActivity({ type: AI_FEEDBACK_TYPES.HELPFUL });
    }
    setTimeout(() => {
      setHideFeedback(true);
    }, 2000);
  };

  const thumbsDown = (e) => {
    if (!hideCustomFeedback) {
      e.stopPropagation();
      toggleFeedbackTooltip();
    } else {
      setIsThumbsDownClicked(true);
      if (sendActivity) {
        sendActivity({ type: AI_FEEDBACK_TYPES.NOT_HELPFUL });
      }
      setTimeout(() => {
        setHideFeedback(true);
      }, 2000);
    }
  };

  if (hideFeedback) {
    return <></>;
  }

  return (
    <>
      {feedbackTooltip}

      {isThumbsDownClicked ? (
        <div id="ai-feedback-thanks">
          <TextStyle variation="subdued">
            {/* <FormattedMessage id="ticket.sideConversation.feedback" /> */}
            <FormattedMessage id="common.feedback.thanks.message" />
          </TextStyle>
        </div>
      ) : (
        <div className="fx g5 actr white-color">
          <div className="position-relative mr-5" ref={feedbackAnchorRef}>
            {!hideTitle && (
              <TextStyle variation="subdued">
                <FormattedMessage id="ticket.sideConversation.feedback" />
              </TextStyle>
            )}
          </div>
          <div className="thumbsup-container position-relative">
            {!hideThumbsUp && (
              <Button {...buttonVariantData} onClick={thumbsUp} size="tiny">
                <div
                  className={`${isThumbsUpClicked ? 'ai-thumbs-pressed' : ''}`}
                >
                  <SVGIcon
                    name="LikeThumb"
                    color={isThumbsUpClicked ? '#77BA6D' : '#fff'}
                  />
                </div>
              </Button>
            )}
            {isThumbsUpClicked && (
              <div className="sun-flair position-absolute">
                <SVGIcon name="SunFlair" color="#77BA6D" />
              </div>
            )}
          </div>

          <Button {...buttonVariantData} onClick={thumbsDown} size="tiny">
            <span className="position-relative">
              <SVGIcon name="ThumbsDownOutline" color="#fff" />
            </span>
          </Button>
        </div>
      )}
    </>
  );
};

export default withErrorBoundary(AIFeedback);
